import { inject, Injectable } from '@angular/core';
import { Query } from '@datorama/akita';

import { BudgetCurrencyState } from './budget-currency.model';
import { BudgetCurrencyStore } from './budget-currency.store';

@Injectable({ providedIn: 'root' })
export class BudgetCurrencyQuery extends Query<BudgetCurrencyState> {
  protected store: BudgetCurrencyStore;

  constructor() {
    const store = inject(BudgetCurrencyStore);

    super(store);

    this.store = store;
  }
}
